import { ArrowRightIcon } from '@heroicons/react/24/outline';
import { cn } from '@theprintbar/shared';
import { ComponentProps } from 'react';
import { OutlineButton } from '../Button';

interface CarouselNextButtonProps extends ComponentProps<typeof OutlineButton> {
	carouselKey?: string;
}

export const CarouselNextButton = ({ children, carouselKey, className, ...props }: CarouselNextButtonProps) => {
	return (
		<OutlineButton
			className={cn(className, `swiper-${carouselKey}-next`)}
			id={`${carouselKey}-next`}
			circle
			type="button"
			icon={() => <ArrowRightIcon className="w-4 h-4" />}
			{...props}
		>
			{children}
		</OutlineButton>
	);
};
